import React, { Component } from 'react'

export class AsLegendCategory extends Component {
  constructor(props) {
    super(props);
    this.ref = React.createRef();
  }

  componentDidUpdate() {
    this.ref.current.data = this.props.data
  }

  render() {
    return (
      <as-legend-category ref={this.ref} slot={this.props.slot} orientation={this.props.orientation}></as-legend-category>
    )
  }
}

export default AsLegendCategory


